import { Select } from 'antd';
import classnames from 'classnames';
import styles from 'components/common/LogicSelector/index.less';
import React, { useEffect, useState } from 'react';

import type { ILogicSelector, TLogicOperator } from '@components/common/LogicSelector/typed';

const AND = 'AND';
const OR = 'OR';

const options = [
  {
    value: AND,
    label: AND,
  },
  {
    value: OR,
    label: OR,
  },
];

const LogicSelector: React.FC<ILogicSelector> = ({
  disabled,
  value = OR,
  active = false,
  logicLabelStyle,
  onChange,
}) => {
  const [selectValue, setSelectValue] = useState<TLogicOperator>(value);

  const handleSelectChange = (value: TLogicOperator) => {
    if (!disabled) {
      setSelectValue(value);
      onChange?.(value);
    }
  };

  useEffect(() => {
    setSelectValue(value);
  }, [value]);

  return (
    <div className={styles.logicSelector}>
      {onChange && active && !disabled ? (
        <Select
          disabled={disabled}
          value={selectValue}
          onChange={handleSelectChange}
          options={options}
          dropdownStyle={{ minWidth: 'fit-content' }}
        />
      ) : (
        <div
          className={classnames(styles.logicLabel, {
            [styles.logicLabelAnd]: !active && value === AND,
            [styles.logicLabelOr]: !active && value === OR,
            [styles.logicLabelActive]: active,
          })}
          style={logicLabelStyle}
        >
          <span>{selectValue}</span>
        </div>
      )}
    </div>
  );
};

export default LogicSelector;
